import { E as ie, e as se } from "./ElementResolution-BiRkFPHH.js";
import { r as ae } from "./random-id-aENvrLj2.js";
import { A as wt, o as ct, n as W, g as Mt, s as re } from "./strategies-D98BLkeE.js";
import { L as Ge } from "./strategies-D98BLkeE.js";
import { f as qt, a as Wt } from "./first-focusable-in-C_FjNeTy.js";
import { u as Vt } from "./focusable-selectors-BazEJmRZ.js";
import { S as le, r as ce } from "./slottable-request-event-B1mW6PN4.js";
import { i as he, x as mt } from "./lit-element-6iugfgmM.js";
import { l as pe } from "./query-assigned-elements-B8U94KLQ.js";
import { t as de } from "./state-STZTbIJp.js";
import { o as ue } from "./style-map-DBc4Yfgo.js";
import { n as N } from "./property-BWlAHqg_.js";
import { i as St } from "./query-D8_rwLua.js";
import { o as st } from "./if-defined-D-RhGngI.js";
class bt {
  constructor(t, n) {
    this.x = 0, this.y = 0, this.x = t, this.y = n;
  }
  updateBoundingClientRect(t, n) {
    this.x = t, this.y = n, wt.update();
  }
  getBoundingClientRect() {
    return { width: 0, height: 0, top: this.y, right: this.x, y: this.y, x: this.x, bottom: this.y, left: this.x, toJSON() {
    } };
  }
}
class Ut extends Event {
  constructor() {
    super("beforetoggle", { bubbles: !1, composed: !1 }), this.currentState = "open", this.newState = "closed";
  }
}
class zt extends Event {
  constructor() {
    super("beforetoggle", { bubbles: !1, composed: !1 }), this.currentState = "closed", this.newState = "open";
  }
}
class G extends Event {
  constructor(t, n, { publish: o, interaction: s, reason: i }) {
    super(t, { bubbles: o, composed: o }), this.overlay = n, this.detail = { interaction: s, reason: i };
  }
}
const me = CSS.supports("(overlay: auto)");
function Lt(e) {
  let t = !1;
  try {
    t = e.matches(":popover-open");
  } catch {
  }
  let n = !1;
  try {
    n = e.matches(":open");
  } catch {
  }
  return t || n;
}
const fe = "showPopover" in document.createElement("div"), kt = new class {
  constructor() {
    this.root = document.body, this.stack = [], this.handleScroll = (e) => {
      e.target !== document && e.target !== document.documentElement && e.target !== document.body || this.stack.forEach((t) => {
        t.open && (t.type === "auto" && t.triggerElement instanceof HTMLElement && t.triggerElement.closest("sp-picker, sp-action-menu") && e.stopPropagation(), document.dispatchEvent(new CustomEvent("sp-update-overlays", { bubbles: !0, composed: !0, cancelable: !0 })));
      });
    }, this.handlePointerdown = (e) => {
      this.pointerdownPath = e.composedPath(), this.lastOverlay = this.stack[this.stack.length - 1];
    }, this.handlePointerup = () => {
      const e = this.pointerdownPath;
      if (this.pointerdownPath = void 0, !this.stack.length || e == null || !e.length) return;
      const t = this.lastOverlay;
      this.lastOverlay = void 0;
      const n = this.stack.length - 1, o = this.stack.filter((s, i) => !(e.find((a) => a === s || a === (s == null ? void 0 : s.triggerElement) && (s == null ? void 0 : s.type) === "hint" || i === n && s !== t && s.triggerInteraction === "longpress") || s.shouldPreventClose() || s.type === "manual" || s.type === "modal" && t !== s));
      o.reverse(), o.forEach((s) => {
        this.closeOverlay(s);
        let i = s.parentOverlayToForceClose;
        for (; i; ) this.closeOverlay(i), i = i.parentOverlayToForceClose;
      });
    }, this.handleBeforetoggle = (e) => {
      const { target: t, newState: n } = e;
      n !== "open" && this.closeOverlay(t);
    }, this.handleKeydown = (e) => {
      if (e.code !== "Escape" || !this.stack.length) return;
      const t = this.stack[this.stack.length - 1];
      (t == null ? void 0 : t.type) !== "page" ? (t == null ? void 0 : t.type) !== "manual" ? fe || t && this.closeOverlay(t) : this.closeOverlay(t) : e.preventDefault();
    }, this.bindEvents();
  }
  get document() {
    return this.root.ownerDocument || document;
  }
  bindEvents() {
    this.document.addEventListener("pointerdown", this.handlePointerdown), this.document.addEventListener("pointerup", this.handlePointerup), this.document.addEventListener("keydown", this.handleKeydown), this.document.addEventListener("scroll", this.handleScroll, { capture: !0 });
  }
  closeOverlay(e) {
    const t = this.stack.indexOf(e);
    t > -1 && this.stack.splice(t, 1), e.open = !1;
  }
  overlaysByTriggerElement(e) {
    return this.stack.filter((t) => t.triggerElement === e);
  }
  add(e) {
    if (this.stack.includes(e)) {
      const t = this.stack.indexOf(e);
      t > -1 && (this.stack.splice(t, 1), this.stack.push(e));
    } else {
      if (e.type === "auto" || e.type === "modal" || e.type === "page") {
        const t = "sp-overlay-query-path", n = new Event(t, { composed: !0, bubbles: !0 });
        e.addEventListener(t, (o) => {
          const s = o.composedPath();
          this.stack.forEach((i) => {
            !s.find((a) => a === i) && i.type !== "manual" && i.type !== "modal" && this.closeOverlay(i);
          });
        }, { once: !0 }), e.dispatchEvent(n);
      } else if (e.type === "hint") {
        if (this.stack.some((t) => t.type !== "manual" && t.triggerElement && t.triggerElement === e.triggerElement)) return void (e.open = !1);
        this.stack.forEach((t) => {
          t.type === "hint" && this.closeOverlay(t);
        });
      }
      requestAnimationFrame(() => {
        this.stack.push(e), e.addEventListener("beforetoggle", this.handleBeforetoggle, { once: !0 });
      });
    }
  }
  remove(e) {
    this.closeOverlay(e);
  }
}(), K = Math.min, _ = Math.max, ht = Math.round, at = Math.floor, X = (e) => ({ x: e, y: e }), ge = { left: "right", right: "left", bottom: "top", top: "bottom" }, ye = { start: "end", end: "start" };
function gt(e, t, n) {
  return _(e, K(t, n));
}
function et(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function j(e) {
  return e.split("-")[0];
}
function Z(e) {
  return e.split("-")[1];
}
function It(e) {
  return e === "x" ? "y" : "x";
}
function xt(e) {
  return e === "y" ? "height" : "width";
}
function it(e) {
  return ["top", "bottom"].includes(j(e)) ? "y" : "x";
}
function Et(e) {
  return It(it(e));
}
function ft(e) {
  return e.replace(/start|end/g, (t) => ye[t]);
}
function rt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => ge[t]);
}
function jt(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function pt(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
function At(e, t, n) {
  let { reference: o, floating: s } = e;
  const i = it(t), a = Et(t), l = xt(a), r = j(t), h = i === "y", d = o.x + o.width / 2 - s.width / 2, g = o.y + o.height / 2 - s.height / 2, u = o[l] / 2 - s[l] / 2;
  let p;
  switch (r) {
    case "top":
      p = { x: d, y: o.y - s.height };
      break;
    case "bottom":
      p = { x: d, y: o.y + o.height };
      break;
    case "right":
      p = { x: o.x + o.width, y: g };
      break;
    case "left":
      p = { x: o.x - s.width, y: g };
      break;
    default:
      p = { x: o.x, y: o.y };
  }
  switch (Z(t)) {
    case "start":
      p[a] -= u * (n && h ? -1 : 1);
      break;
    case "end":
      p[a] += u * (n && h ? -1 : 1);
  }
  return p;
}
async function Ot(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: o, y: s, platform: i, rects: a, elements: l, strategy: r } = e, { boundary: h = "clippingAncestors", rootBoundary: d = "viewport", elementContext: g = "floating", altBoundary: u = !1, padding: p = 0 } = et(t, e), c = jt(p), f = l[u ? g === "floating" ? "reference" : "floating" : g], m = pt(await i.getClippingRect({ element: (n = await (i.isElement == null ? void 0 : i.isElement(f))) == null || n ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)), boundary: h, rootBoundary: d, strategy: r })), y = g === "floating" ? { ...a.floating, x: o, y: s } : a.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), w = await (i.isElement == null ? void 0 : i.isElement(v)) && await (i.getScale == null ? void 0 : i.getScale(v)) || { x: 1, y: 1 }, x = pt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({ elements: l, rect: y, offsetParent: v, strategy: r }) : y);
  return { top: (m.top - x.top + c.top) / w.y, bottom: (x.bottom - m.bottom + c.bottom) / w.y, left: (m.left - x.left + c.left) / w.x, right: (x.right - m.right + c.right) / w.x };
}
const ve = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    var n, o;
    const { x: s, y: i, placement: a, middlewareData: l } = t, r = await async function(h, d) {
      const { placement: g, platform: u, elements: p } = h, c = await (u.isRTL == null ? void 0 : u.isRTL(p.floating)), f = j(g), m = Z(g), y = it(g) === "y", v = ["left", "top"].includes(f) ? -1 : 1, w = c && y ? -1 : 1, x = et(d, h);
      let { mainAxis: k, crossAxis: b, alignmentAxis: E } = typeof x == "number" ? { mainAxis: x, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...x };
      return m && typeof E == "number" && (b = m === "end" ? -1 * E : E), y ? { x: b * w, y: k * v } : { x: k * v, y: b * w };
    }(t, e);
    return a === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : { x: s + r.x, y: i + r.y, data: { ...r, placement: a } };
  } };
};
function Y(e) {
  return Kt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function B(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function V(e) {
  var t;
  return (t = (Kt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Kt(e) {
  return e instanceof Node || e instanceof B(e).Node;
}
function U(e) {
  return e instanceof Element || e instanceof B(e).Element;
}
function q(e) {
  return e instanceof HTMLElement || e instanceof B(e).HTMLElement;
}
function Dt(e) {
  return typeof ShadowRoot < "u" && (e instanceof ShadowRoot || e instanceof B(e).ShadowRoot);
}
function nt(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: s } = $(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(s);
}
function we(e) {
  return ["table", "td", "th"].includes(Y(e));
}
function yt(e) {
  const t = Pt(), n = $(e);
  return n.transform !== "none" || n.perspective !== "none" || !!n.containerType && n.containerType !== "normal" || !t && !!n.backdropFilter && n.backdropFilter !== "none" || !t && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Pt() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function dt(e) {
  return ["html", "body", "#document"].includes(Y(e));
}
function $(e) {
  return B(e).getComputedStyle(e);
}
function ut(e) {
  return U(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function tt(e) {
  if (Y(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || Dt(e) && e.host || V(e);
  return Dt(t) ? t.host : t;
}
function Xt(e) {
  const t = tt(e);
  return dt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : q(t) && nt(t) ? t : Xt(t);
}
function ot(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = Xt(e), i = s === ((o = e.ownerDocument) == null ? void 0 : o.body), a = B(s);
  return i ? t.concat(a, a.visualViewport || [], nt(s) ? s : [], a.frameElement && n ? ot(a.frameElement) : []) : t.concat(s, ot(s, [], n));
}
function Yt(e) {
  const t = $(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const s = q(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : o, l = ht(n) !== i || ht(o) !== a;
  return l && (n = i, o = a), { width: n, height: o, $: l };
}
function Ct(e) {
  return U(e) ? e : e.contextElement;
}
function Q(e) {
  const t = Ct(e);
  if (!q(t)) return X(1);
  const n = t.getBoundingClientRect(), { width: o, height: s, $: i } = Yt(t);
  let a = (i ? ht(n.width) : n.width) / o, l = (i ? ht(n.height) : n.height) / s;
  return a && Number.isFinite(a) || (a = 1), l && Number.isFinite(l) || (l = 1), { x: a, y: l };
}
const be = X(0);
function Gt(e) {
  const t = B(e);
  return Pt() && t.visualViewport ? { x: t.visualViewport.offsetLeft, y: t.visualViewport.offsetTop } : be;
}
function J(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = Ct(e);
  let a = X(1);
  t && (o ? U(o) && (a = Q(o)) : a = Q(e));
  const l = function(u, p, c) {
    return p === void 0 && (p = !1), !(!c || p && c !== B(u)) && p;
  }(i, n, o) ? Gt(i) : X(0);
  let r = (s.left + l.x) / a.x, h = (s.top + l.y) / a.y, d = s.width / a.x, g = s.height / a.y;
  if (i) {
    const u = B(i), p = o && U(o) ? B(o) : o;
    let c = u, f = c.frameElement;
    for (; f && o && p !== c; ) {
      const m = Q(f), y = f.getBoundingClientRect(), v = $(f), w = y.left + (f.clientLeft + parseFloat(v.paddingLeft)) * m.x, x = y.top + (f.clientTop + parseFloat(v.paddingTop)) * m.y;
      r *= m.x, h *= m.y, d *= m.x, g *= m.y, r += w, h += x, c = B(f), f = c.frameElement;
    }
  }
  return pt({ width: d, height: g, x: r, y: h });
}
const xe = [":popover-open", ":modal"];
function Jt(e) {
  return xe.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Qt(e) {
  return J(V(e)).left + ut(e).scrollLeft;
}
function Ft(e, t, n) {
  let o;
  if (t === "viewport") o = function(s, i) {
    const a = B(s), l = V(s), r = a.visualViewport;
    let h = l.clientWidth, d = l.clientHeight, g = 0, u = 0;
    if (r) {
      h = r.width, d = r.height;
      const p = Pt();
      (!p || p && i === "fixed") && (g = r.offsetLeft, u = r.offsetTop);
    }
    return { width: h, height: d, x: g, y: u };
  }(e, n);
  else if (t === "document") o = function(s) {
    const i = V(s), a = ut(s), l = s.ownerDocument.body, r = _(i.scrollWidth, i.clientWidth, l.scrollWidth, l.clientWidth), h = _(i.scrollHeight, i.clientHeight, l.scrollHeight, l.clientHeight);
    let d = -a.scrollLeft + Qt(s);
    const g = -a.scrollTop;
    return $(l).direction === "rtl" && (d += _(i.clientWidth, l.clientWidth) - r), { width: r, height: h, x: d, y: g };
  }(V(e));
  else if (U(t)) o = function(s, i) {
    const a = J(s, !0, i === "fixed"), l = a.top + s.clientTop, r = a.left + s.clientLeft, h = q(s) ? Q(s) : X(1);
    return { width: s.clientWidth * h.x, height: s.clientHeight * h.y, x: r * h.x, y: l * h.y };
  }(t, n);
  else {
    const s = Gt(e);
    o = { ...t, x: t.x - s.x, y: t.y - s.y };
  }
  return pt(o);
}
function Zt(e, t) {
  const n = tt(e);
  return !(n === t || !U(n) || dt(n)) && ($(n).position === "fixed" || Zt(n, t));
}
function Ee(e, t, n) {
  const o = q(t), s = V(t), i = n === "fixed", a = J(e, !0, i, t);
  let l = { scrollLeft: 0, scrollTop: 0 };
  const r = X(0);
  if (o || !o && !i) if ((Y(t) !== "body" || nt(s)) && (l = ut(t)), o) {
    const h = J(t, !0, i, t);
    r.x = h.x + t.clientLeft, r.y = h.y + t.clientTop;
  } else s && (r.x = Qt(s));
  return { x: a.left + l.scrollLeft - r.x, y: a.top + l.scrollTop - r.y, width: a.width, height: a.height };
}
function Ht(e, t) {
  return q(e) && $(e).position !== "fixed" ? t ? t(e) : e.offsetParent : null;
}
function _t(e, t) {
  const n = B(e);
  if (!q(e) || Jt(e)) return n;
  let o = Ht(e, t);
  for (; o && we(o) && $(o).position === "static"; ) o = Ht(o, t);
  return o && (Y(o) === "html" || Y(o) === "body" && $(o).position === "static" && !yt(o)) ? n : o || function(s) {
    let i = tt(s);
    for (; q(i) && !dt(i); ) {
      if (yt(i)) return i;
      i = tt(i);
    }
    return null;
  }(e) || n;
}
const Oe = { convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { elements: t, rect: n, offsetParent: o, strategy: s } = e;
  const i = s === "fixed", a = V(o), l = !!t && Jt(t.floating);
  if (o === a || l && i) return n;
  let r = { scrollLeft: 0, scrollTop: 0 }, h = X(1);
  const d = X(0), g = q(o);
  if ((g || !g && !i) && ((Y(o) !== "body" || nt(a)) && (r = ut(o)), q(o))) {
    const u = J(o);
    h = Q(o), d.x = u.x + o.clientLeft, d.y = u.y + o.clientTop;
  }
  return { width: n.width * h.x, height: n.height * h.y, x: n.x * h.x - r.scrollLeft * h.x + d.x, y: n.y * h.y - r.scrollTop * h.y + d.y };
}, getDocumentElement: V, getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: o, strategy: s } = e;
  const i = [...n === "clippingAncestors" ? function(r, h) {
    const d = h.get(r);
    if (d) return d;
    let g = ot(r, [], !1).filter((f) => U(f) && Y(f) !== "body"), u = null;
    const p = $(r).position === "fixed";
    let c = p ? tt(r) : r;
    for (; U(c) && !dt(c); ) {
      const f = $(c), m = yt(c);
      m || f.position !== "fixed" || (u = null), (p ? !m && !u : !m && f.position === "static" && u && ["absolute", "fixed"].includes(u.position) || nt(c) && !m && Zt(r, c)) ? g = g.filter((y) => y !== c) : u = f, c = tt(c);
    }
    return h.set(r, g), g;
  }(t, this._c) : [].concat(n), o], a = i[0], l = i.reduce((r, h) => {
    const d = Ft(t, h, s);
    return r.top = _(d.top, r.top), r.right = K(d.right, r.right), r.bottom = K(d.bottom, r.bottom), r.left = _(d.left, r.left), r;
  }, Ft(t, a, s));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, getOffsetParent: _t, getElementRects: async function(e) {
  const t = this.getOffsetParent || _t, n = this.getDimensions;
  return { reference: Ee(e.reference, await t(e.floating), e.strategy), floating: { x: 0, y: 0, ...await n(e.floating) } };
}, getClientRects: function(e) {
  return Array.from(e.getClientRects());
}, getDimensions: function(e) {
  const { width: t, height: n } = Yt(e);
  return { width: t, height: n };
}, getScale: Q, isElement: U, isRTL: function(e) {
  return $(e).direction === "rtl";
} };
function Bt(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: s = !0, ancestorResize: i = !0, elementResize: a = typeof ResizeObserver == "function", layoutShift: l = typeof IntersectionObserver == "function", animationFrame: r = !1 } = o, h = Ct(e), d = s || i ? [...h ? ot(h) : [], ...ot(t)] : [];
  d.forEach((m) => {
    s && m.addEventListener("scroll", n, { passive: !0 }), i && m.addEventListener("resize", n);
  });
  const g = h && l ? function(m, y) {
    let v, w = null;
    const x = V(m);
    function k() {
      var b;
      clearTimeout(v), (b = w) == null || b.disconnect(), w = null;
    }
    return function b(E, S) {
      E === void 0 && (E = !1), S === void 0 && (S = 1), k();
      const { left: H, top: M, width: A, height: P } = m.getBoundingClientRect();
      if (E || y(), !A || !P) return;
      const D = { rootMargin: -at(M) + "px " + -at(x.clientWidth - (H + A)) + "px " + -at(x.clientHeight - (M + P)) + "px " + -at(H) + "px", threshold: _(0, K(1, S)) || 1 };
      let C = !0;
      function R(T) {
        const O = T[0].intersectionRatio;
        if (O !== S) {
          if (!C) return b();
          O ? b(!1, O) : v = setTimeout(() => {
            b(!1, 1e-7);
          }, 100);
        }
        C = !1;
      }
      try {
        w = new IntersectionObserver(R, { ...D, root: x.ownerDocument });
      } catch {
        w = new IntersectionObserver(R, D);
      }
      w.observe(m);
    }(!0), k;
  }(h, n) : null;
  let u, p = -1, c = null;
  a && (c = new ResizeObserver((m) => {
    let [y] = m;
    y && y.target === h && c && (c.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var v;
      (v = c) == null || v.observe(t);
    })), n();
  }), h && !r && c.observe(h), c.observe(t));
  let f = r ? J(e) : null;
  return r && function m() {
    const y = J(e);
    !f || y.x === f.x && y.y === f.y && y.width === f.width && y.height === f.height || n(), f = y, u = requestAnimationFrame(m);
  }(), n(), () => {
    var m;
    d.forEach((y) => {
      s && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), g == null || g(), (m = c) == null || m.disconnect(), c = null, r && cancelAnimationFrame(u);
  };
}
const Pe = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: o, placement: s } = t, { mainAxis: i = !0, crossAxis: a = !1, limiter: l = { fn: (m) => {
      let { x: y, y: v } = m;
      return { x: y, y: v };
    } }, ...r } = et(e, t), h = { x: n, y: o }, d = await Ot(t, r), g = it(j(s)), u = It(g);
    let p = h[u], c = h[g];
    if (i) {
      const m = u === "y" ? "bottom" : "right";
      p = gt(p + d[u === "y" ? "top" : "left"], p, p - d[m]);
    }
    if (a) {
      const m = g === "y" ? "bottom" : "right";
      c = gt(c + d[g === "y" ? "top" : "left"], c, c - d[m]);
    }
    const f = l.fn({ ...t, [u]: p, [g]: c });
    return { ...f, data: { x: f.x - n, y: f.y - o } };
  } };
}, $t = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n, o;
    const { placement: s, middlewareData: i, rects: a, initialPlacement: l, platform: r, elements: h } = t, { mainAxis: d = !0, crossAxis: g = !0, fallbackPlacements: u, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: c = "none", flipAlignment: f = !0, ...m } = et(e, t);
    if ((n = i.arrow) != null && n.alignmentOffset) return {};
    const y = j(s), v = j(l) === l, w = await (r.isRTL == null ? void 0 : r.isRTL(h.floating)), x = u || (v || !f ? [rt(l)] : function(P) {
      const D = rt(P);
      return [ft(P), D, ft(D)];
    }(l));
    u || c === "none" || x.push(...function(P, D, C, R) {
      const T = Z(P);
      let O = function(z, I, ee) {
        const Rt = ["left", "right"], Tt = ["right", "left"], ne = ["top", "bottom"], oe = ["bottom", "top"];
        switch (z) {
          case "top":
          case "bottom":
            return ee ? I ? Tt : Rt : I ? Rt : Tt;
          case "left":
          case "right":
            return I ? ne : oe;
          default:
            return [];
        }
      }(j(P), C === "start", R);
      return T && (O = O.map((z) => z + "-" + T), D && (O = O.concat(O.map(ft)))), O;
    }(l, f, c, w));
    const k = [l, ...x], b = await Ot(t, m), E = [];
    let S = ((o = i.flip) == null ? void 0 : o.overflows) || [];
    if (d && E.push(b[y]), g) {
      const P = function(D, C, R) {
        R === void 0 && (R = !1);
        const T = Z(D), O = Et(D), z = xt(O);
        let I = O === "x" ? T === (R ? "end" : "start") ? "right" : "left" : T === "start" ? "bottom" : "top";
        return C.reference[z] > C.floating[z] && (I = rt(I)), [I, rt(I)];
      }(s, a, w);
      E.push(b[P[0]], b[P[1]]);
    }
    if (S = [...S, { placement: s, overflows: E }], !E.every((P) => P <= 0)) {
      var H, M;
      const P = (((H = i.flip) == null ? void 0 : H.index) || 0) + 1, D = k[P];
      if (D) return { data: { index: P, overflows: S }, reset: { placement: D } };
      let C = (M = S.filter((R) => R.overflows[0] <= 0).sort((R, T) => R.overflows[1] - T.overflows[1])[0]) == null ? void 0 : M.placement;
      if (!C) switch (p) {
        case "bestFit": {
          var A;
          const R = (A = S.map((T) => [T.placement, T.overflows.filter((O) => O > 0).reduce((O, z) => O + z, 0)]).sort((T, O) => T[1] - O[1])[0]) == null ? void 0 : A[0];
          R && (C = R);
          break;
        }
        case "initialPlacement":
          C = l;
      }
      if (s !== C) return { reset: { placement: C } };
    }
    return {};
  } };
}, Ce = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(t) {
    const { placement: n, rects: o, platform: s, elements: i } = t, { apply: a = () => {
    }, ...l } = et(e, t), r = await Ot(t, l), h = j(n), d = Z(n), g = it(n) === "y", { width: u, height: p } = o.floating;
    let c, f;
    h === "top" || h === "bottom" ? (c = h, f = d === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = h, c = d === "end" ? "top" : "bottom");
    const m = p - r[c], y = u - r[f], v = !t.middlewareData.shift;
    let w = m, x = y;
    if (g) {
      const b = u - r.left - r.right;
      x = d || v ? K(y, b) : b;
    } else {
      const b = p - r.top - r.bottom;
      w = d || v ? K(m, b) : b;
    }
    if (v && !d) {
      const b = _(r.left, 0), E = _(r.right, 0), S = _(r.top, 0), H = _(r.bottom, 0);
      g ? x = u - 2 * (b !== 0 || E !== 0 ? b + E : _(r.left, r.right)) : w = p - 2 * (S !== 0 || H !== 0 ? S + H : _(r.top, r.bottom));
    }
    await a({ ...t, availableWidth: x, availableHeight: w });
    const k = await s.getDimensions(i.floating);
    return u !== k.width || p !== k.height ? { reset: { rects: !0 } } : {};
  } };
}, Re = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { x: n, y: o, placement: s, rects: i, platform: a, elements: l, middlewareData: r } = t, { element: h, padding: d = 0 } = et(e, t) || {};
  if (h == null) return {};
  const g = jt(d), u = { x: n, y: o }, p = Et(s), c = xt(p), f = await a.getDimensions(h), m = p === "y", y = m ? "top" : "left", v = m ? "bottom" : "right", w = m ? "clientHeight" : "clientWidth", x = i.reference[c] + i.reference[p] - u[p] - i.floating[c], k = u[p] - i.reference[p], b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(h));
  let E = b ? b[w] : 0;
  E && await (a.isElement == null ? void 0 : a.isElement(b)) || (E = l.floating[w] || i.floating[c]);
  const S = x / 2 - k / 2, H = E / 2 - f[c] / 2 - 1, M = K(g[y], H), A = K(g[v], H), P = M, D = E - f[c] - A, C = E / 2 - f[c] / 2 + S, R = gt(P, C, D), T = !r.arrow && Z(s) != null && C !== R && i.reference[c] / 2 - (C < P ? M : A) - f[c] / 2 < 0, O = T ? C < P ? C - P : C - D : 0;
  return { [p]: u[p] + O, data: { [p]: R, centerOffset: C - R - O, ...T && { alignmentOffset: O } }, reset: T };
} }), Te = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), s = { platform: Oe, ...n }, i = { ...s.platform, _c: o };
  return (async (a, l, r) => {
    const { placement: h = "bottom", strategy: d = "absolute", middleware: g = [], platform: u } = r, p = g.filter(Boolean), c = await (u.isRTL == null ? void 0 : u.isRTL(l));
    let f = await u.getElementRects({ reference: a, floating: l, strategy: d }), { x: m, y } = At(f, h, c), v = h, w = {}, x = 0;
    for (let k = 0; k < p.length; k++) {
      const { name: b, fn: E } = p[k], { x: S, y: H, data: M, reset: A } = await E({ x: m, y, initialPlacement: h, placement: v, strategy: d, middlewareData: w, rects: f, platform: u, elements: { reference: a, floating: l } });
      m = S ?? m, y = H ?? y, w = { ...w, [b]: { ...w[b], ...M } }, A && x <= 50 && (x++, typeof A == "object" && (A.placement && (v = A.placement), A.rects && (f = A.rects === !0 ? await u.getElementRects({ reference: a, floating: l, strategy: d }) : A.rects), { x: m, y } = At(f, v, c)), k = -1);
    }
    return { x: m, y, placement: v, strategy: d, middlewareData: w };
  })(e, t, { ...s, platform: i });
};
function lt(e) {
  if (e === void 0) return 0;
  const t = window.devicePixelRatio || 1;
  return Math.round(e * t) / t;
}
const Se = (e) => {
  var t;
  return (t = { left: ["right", "bottom", "top"], "left-start": ["right-start", "bottom", "top"], "left-end": ["right-end", "bottom", "top"], right: ["left", "bottom", "top"], "right-start": ["left-start", "bottom", "top"], "right-end": ["left-end", "bottom", "top"], top: ["bottom", "left", "right"], "top-start": ["bottom-start", "left", "right"], "top-end": ["bottom-end", "left", "right"], bottom: ["top", "left", "right"], "bottom-start": ["top-start", "left", "right"], "bottom-end": ["top-end", "left", "right"] }[e]) != null ? t : [e];
};
class Le {
  constructor(t) {
    this.originalPlacements = /* @__PURE__ */ new WeakMap(), this.allowPlacementUpdate = !1, this.closeForAncestorUpdate = () => {
      !this.allowPlacementUpdate && this.options.type !== "modal" && this.cleanup && this.target.dispatchEvent(new Event("close", { bubbles: !0 })), this.allowPlacementUpdate = !1;
    }, this.updatePlacement = () => {
      this.computePlacement();
    }, this.resetOverlayPosition = () => {
      !this.target || !this.options || (this.clearOverlayPosition(), this.host.offsetHeight, this.computePlacement());
    }, this.host = t, this.host.addController(this);
  }
  async placeOverlay(t = this.target, n = this.options) {
    if (this.target = t, this.options = n, !t || !n) return;
    const o = Bt(n.trigger, t, this.closeForAncestorUpdate, { ancestorResize: !1, elementResize: !1, layoutShift: !1 }), s = Bt(n.trigger, t, this.updatePlacement, { ancestorScroll: !1 });
    this.cleanup = () => {
      var i;
      (i = this.host.elements) == null || i.forEach((a) => {
        a.addEventListener("sp-closed", () => {
          const l = this.originalPlacements.get(a);
          l && a.setAttribute("placement", l), this.originalPlacements.delete(a);
        }, { once: !0 });
      }), o(), s();
    };
  }
  async computePlacement() {
    var t, n;
    const { options: o, target: s } = this;
    await (document.fonts ? document.fonts.ready : Promise.resolve());
    const i = o.trigger instanceof HTMLElement ? $t() : $t({ padding: 8, fallbackPlacements: Se(o.placement) }), [a = 0, l = 0] = Array.isArray(o == null ? void 0 : o.offset) ? o.offset : [o.offset, 0], r = (t = this.host.elements.find((c) => c.tipElement)) == null ? void 0 : t.tipElement, h = [ve({ mainAxis: a, crossAxis: l }), Pe({ padding: 8 }), i, Ce({ padding: 8, apply: ({ availableWidth: c, availableHeight: f, rects: { floating: m } }) => {
      const y = Math.max(100, Math.floor(f)), v = m.height;
      this.initialHeight = this.isConstrained && this.initialHeight || v, this.isConstrained = v < this.initialHeight || y <= v;
      const w = this.isConstrained ? `${y}px` : "";
      Object.assign(s.style, { maxWidth: `${Math.floor(c)}px`, maxHeight: w });
    } }), ...r ? [Re({ element: r, padding: o.tipPadding || 8 })] : []], { x: d, y: g, placement: u, middlewareData: p } = await Te(o.trigger, s, { placement: o.placement, middleware: h, strategy: "fixed" });
    if (Object.assign(s.style, { top: "0px", left: "0px", translate: `${lt(d)}px ${lt(g)}px` }), s.setAttribute("actual-placement", u), (n = this.host.elements) == null || n.forEach((c) => {
      this.originalPlacements.has(c) || this.originalPlacements.set(c, c.getAttribute("placement")), c.setAttribute("placement", u);
    }), r && p.arrow) {
      const { x: c, y: f } = p.arrow;
      Object.assign(r.style, { top: u.startsWith("right") || u.startsWith("left") ? "0px" : "", left: u.startsWith("bottom") || u.startsWith("top") ? "0px" : "", translate: `${lt(c)}px ${lt(f)}px` });
    }
  }
  clearOverlayPosition() {
    this.target && (this.target.style.removeProperty("max-height"), this.target.style.removeProperty("max-width"), this.initialHeight = void 0, this.isConstrained = !1);
  }
  hostConnected() {
    document.addEventListener("sp-update-overlays", this.resetOverlayPosition);
  }
  hostUpdated() {
    var t;
    this.host.open || ((t = this.cleanup) == null || t.call(this), this.cleanup = void 0);
  }
  hostDisconnected() {
    var t;
    (t = this.cleanup) == null || t.call(this), this.cleanup = void 0, document.removeEventListener("sp-update-overlays", this.resetOverlayPosition);
  }
}
const ke = he`
    :host{pointer-events:none;--swc-overlay-animation-distance:var(--spectrum-spacing-100);display:contents}:host(:has(>sp-tooltip)){--swc-overlay-animation-distance:var(--spectrum-tooltip-animation-distance)}.dialog{box-sizing:border-box;max-height:calc(100vh - 16px);max-height:calc(100dvh - 16px);max-width:calc(100vw - 16px);height:auto;--sp-overlay-open:true;background:0 0;border:0;margin:0;padding:0;display:flex;position:fixed;inset:0 auto auto 0;overflow:visible;opacity:1!important}.dialog:not([is-visible]){display:none}.dialog:focus{outline:none}dialog:modal{--mod-popover-filter:var(--spectrum-popover-filter)}:host(:not([open])) .dialog{--sp-overlay-open:false}.dialog::backdrop{display:none}.dialog:before{content:"";position:absolute;inset:-999em;pointer-events:auto!important}.dialog:not(.not-immediately-closable):before{display:none}.dialog>div{width:100%}::slotted(*){pointer-events:auto;visibility:visible!important}::slotted(sp-popover){position:static}.dialog:not([actual-placement])[placement*=top]{padding-block:var(--swc-overlay-animation-distance);margin-top:var(--swc-overlay-animation-distance)}.dialog:not([actual-placement])[placement*=right]{padding-inline:var(--swc-overlay-animation-distance);margin-left:calc(-1*var(--swc-overlay-animation-distance))}.dialog:not([actual-placement])[placement*=bottom]{padding-block:var(--swc-overlay-animation-distance);margin-top:calc(-1*var(--swc-overlay-animation-distance))}.dialog:not([actual-placement])[placement*=left]{padding-inline:var(--swc-overlay-animation-distance);margin-left:var(--swc-overlay-animation-distance)}.dialog[actual-placement*=top]{padding-block:var(--swc-overlay-animation-distance);margin-top:var(--swc-overlay-animation-distance)}.dialog[actual-placement*=right]{padding-inline:var(--swc-overlay-animation-distance);margin-left:calc(-1*var(--swc-overlay-animation-distance))}.dialog[actual-placement*=bottom]{padding-block:var(--swc-overlay-animation-distance);margin-top:calc(-1*var(--swc-overlay-animation-distance))}.dialog[actual-placement*=left]{padding-inline:var(--swc-overlay-animation-distance);margin-left:var(--swc-overlay-animation-distance)}slot[name=longpress-describedby-descriptor]{display:none}@supports selector(:open){.dialog{opacity:0}.dialog:open{opacity:1;--mod-popover-filter:var(--spectrum-popover-filter)}}@supports selector(:popover-open){.dialog{opacity:0}.dialog:popover-open{opacity:1;--mod-popover-filter:var(--spectrum-popover-filter)}}@supports (overlay:auto){.dialog{transition:all var(--mod-overlay-animation-duration,var(--spectrum-animation-duration-100,.13s)),translate 0s,display var(--mod-overlay-animation-duration,var(--spectrum-animation-duration-100,.13s));transition-behavior:allow-discrete;display:none}.dialog:popover-open{display:flex}}@supports (not selector(:open)) and (not selector(:popover-open)){:host:not([open]) .dialog{pointer-events:none}.dialog[actual-placement]{z-index:calc(var(--swc-overlay-z-index-base,1000) + var(--swc-overlay-open-count))}}
`;
var Ae = Object.defineProperty, De = Object.getOwnPropertyDescriptor, F = (e, t, n, o) => {
  for (var s, i = o > 1 ? void 0 : o ? De(t, n) : t, a = e.length - 1; a >= 0; a--) (s = e[a]) && (i = (o ? s(t, n, i) : s(i)) || i);
  return o && i && Ae(t, n, i), i;
};
const Fe = "showPopover" in document.createElement("div");
let te = /* @__PURE__ */ function(e) {
  return class extends e {
    async manageDelay(t) {
      t !== !1 && t === this.open ? this.delayed && await ct.openTimer(this) && (this.open = !t) : ct.close(this);
    }
    async shouldHidePopover(t) {
      if (t && this.open !== t) return;
      const n = async ({ newState: o } = {}) => {
        o !== "open" && await this.placementController.resetOverlayPosition();
      };
      Lt(this.dialogEl) ? this.dialogEl.addEventListener("toggle", n, { once: !0 }) : n();
    }
    shouldShowPopover(t) {
      let n = !1;
      try {
        n = this.dialogEl.matches(":popover-open");
      } catch {
      }
      let o = !1;
      try {
        o = this.dialogEl.matches(":open");
      } catch {
      }
      t && this.open === t && !n && !o && this.isConnected && (this.dialogEl.showPopover(), this.managePosition());
    }
    async ensureOnDOM(t) {
      me || await this.shouldHidePopover(t), this.shouldShowPopover(t), await W();
    }
    async makeTransition(t) {
      if (this.open !== t) return null;
      let n = null;
      const o = (i, a) => () => {
        if (i.open = t, a === 0) {
          const l = t ? zt : Ut;
          this.dispatchEvent(new l());
        }
        t && (i.matches(Vt) && (n = i), n = n || qt(i), !n) && i.querySelectorAll("slot").forEach((l) => {
          n || (n = Wt(l));
        });
      }, s = (i, a) => async () => {
        if (this.open !== t) return;
        const l = t ? "sp-opened" : "sp-closed";
        if (a > 0) return void i.dispatchEvent(new G(l, this, { interaction: this.type, publish: !1 }));
        const r = async () => {
          if (this.open !== t) return;
          await W();
          const d = this.triggerElement instanceof bt;
          this.dispatchEvent(new G(l, this, { interaction: this.type, publish: d })), i.dispatchEvent(new G(l, this, { interaction: this.type, publish: !1 })), this.triggerElement && !d && this.triggerElement.dispatchEvent(new G(l, this, { interaction: this.type, publish: !0 })), this.state = t ? "opened" : "closed", this.returnFocus(), await W(), await W(), t === this.open && t === !1 && this.requestSlottable();
        };
        if (this.open !== t) return;
        const h = Lt(this.dialogEl);
        t !== !0 && h && this.isConnected ? (this.dialogEl.addEventListener("beforetoggle", () => {
          r();
        }, { once: !0 }), this.dialogEl.hidePopover()) : r();
      };
      return this.elements.forEach((i, a) => {
        Mt(i, o(i, a), s(i, a));
      }), n;
    }
  };
}(wt);
var Nt;
Fe || (Nt = wt, te = class extends Nt {
  async managePopoverOpen() {
    await this.managePosition();
  }
  async manageDelay(e) {
    e !== !1 && e === this.open ? this.delayed && await ct.openTimer(this) && (this.open = !e) : ct.close(this);
  }
  async ensureOnDOM(e) {
    document.body.offsetHeight;
  }
  async makeTransition(e) {
    if (this.open !== e) return null;
    let t = null;
    const n = (s, i) => () => {
      if (e === this.open) {
        if (s.open = e, i === 0) {
          const a = e ? zt : Ut;
          this.dispatchEvent(new a());
        }
        e !== !0 || (s.matches(Vt) && (t = s), t = t || qt(s), t) || s.querySelectorAll("slot").forEach((a) => {
          t || (t = Wt(a));
        });
      }
    }, o = (s, i) => async () => {
      if (this.open !== e) return;
      const a = e ? "sp-opened" : "sp-closed";
      if (s.dispatchEvent(new G(a, this, { interaction: this.type })), i > 0) return;
      const l = this.triggerElement instanceof bt;
      this.dispatchEvent(new G(a, this, { interaction: this.type, publish: l })), this.triggerElement && !l && this.triggerElement.dispatchEvent(new G(a, this, { interaction: this.type, publish: !0 })), this.state = e ? "opened" : "closed", this.returnFocus(), await W(), await W(), e === this.open && e === !1 && this.requestSlottable();
    };
    return this.elements.forEach((s, i) => {
      Mt(s, n(s, i), o(s, i));
    }), t;
  }
});
const L = class vt extends te {
  constructor() {
    super(...arguments), this._delayed = !1, this._disabled = !1, this.offset = 0, this._open = !1, this.lastRequestSlottableState = !1, this.receivesFocus = "auto", this._state = "closed", this.triggerElement = null, this.type = "auto", this.wasOpen = !1, this._focusTrap = null, this.closeOnFocusOut = (t) => {
      if (!t.relatedTarget) return;
      const n = new Event("overlay-relation-query", { bubbles: !0, composed: !0 });
      t.relatedTarget.addEventListener(n.type, (o) => {
        o.composedPath().some((s) => s === this) || (this.open = !1);
      }), t.relatedTarget.dispatchEvent(n);
    }, this.closeOnCancelEvent = () => {
      this.open = !1;
    };
  }
  get delayed() {
    var t;
    return ((t = this.elements.at(-1)) == null ? void 0 : t.hasAttribute("delayed")) || this._delayed;
  }
  set delayed(t) {
    this._delayed = t;
  }
  get disabled() {
    return this._disabled;
  }
  set disabled(t) {
    var n;
    this._disabled = t, t ? ((n = this.strategy) == null || n.abort(), this.wasOpen = this.open, this.open = !1) : (this.bindEvents(), this.open = this.open || this.wasOpen, this.wasOpen = !1);
  }
  get hasNonVirtualTrigger() {
    return !(!this.triggerElement || this.triggerElement instanceof bt);
  }
  get placementController() {
    return this._placementController || (this._placementController = new Le(this)), this._placementController;
  }
  get open() {
    return this._open;
  }
  set open(t) {
    var n;
    t && this.disabled || t !== this.open && ((n = this.strategy) != null && n.activelyOpening && !t || (this._open = t, this.open && (vt.openCount += 1), this.requestUpdate("open", !this.open), this.open && this.requestSlottable()));
  }
  get state() {
    return this._state;
  }
  set state(t) {
    var n;
    if (t === this.state) return;
    const o = this.state;
    this._state = t, (this.state === "opened" || this.state === "closed") && ((n = this.strategy) == null || n.shouldCompleteOpen()), this.requestUpdate("state", o);
  }
  get elementResolver() {
    return this._elementResolver || (this._elementResolver = new ie(this)), this._elementResolver;
  }
  get popoverValue() {
    if ("popover" in this) switch (this.type) {
      case "modal":
        return "auto";
      case "page":
      case "hint":
        return "manual";
      default:
        return this.type;
    }
  }
  get requiresPositioning() {
    return !(this.type === "page" || !this.open || !this.triggerElement || !this.placement && this.type !== "hint");
  }
  managePosition() {
    if (!this.requiresPositioning || !this.open) return;
    const t = this.offset || 0, n = this.triggerElement, o = this.placement || "right", s = this.tipPadding;
    this.placementController.placeOverlay(this.dialogEl, { offset: t, placement: o, tipPadding: s, trigger: n, type: this.type });
  }
  async managePopoverOpen() {
    super.managePopoverOpen();
    const t = this.open;
    if (this.open !== t || (await this.manageDelay(t), this.open !== t) || (this.triggerInteraction === "longpress" && await W(), await this.ensureOnDOM(t), this.open !== t)) return;
    const n = await this.makeTransition(t);
    if (this.open === t) {
      if (t) {
        const o = await import("./focus-trap.esm-CUqTsgSY.js");
        this._focusTrap = o.createFocusTrap(this.dialogEl, { initialFocus: n || void 0, tabbableOptions: { getShadowRoot: !0 }, fallbackFocus: () => (this.dialogEl.setAttribute("tabIndex", "-1"), this.dialogEl), escapeDeactivates: !1 }), (this.type === "modal" || this.type === "page") && this._focusTrap.activate();
      }
      await this.applyFocus(t, n);
    }
  }
  async applyFocus(t, n) {
    if (this.receivesFocus !== "false" && this.type !== "hint") {
      if (await W(), await W(), t === this.open && !this.open) return void (this.hasNonVirtualTrigger && this.contains(this.getRootNode().activeElement) && this.triggerElement.focus());
      n == null || n.focus();
    }
  }
  returnFocus() {
    var t;
    this.open || this.type === "hint" || this.receivesFocus !== "false" && (t = this.triggerElement) != null && t.focus && (this.contains(this.getRootNode().activeElement) || (() => {
      var n, o;
      const s = [];
      let i = document.activeElement;
      for (; (n = i == null ? void 0 : i.shadowRoot) != null && n.activeElement; ) i = i.shadowRoot.activeElement;
      for (; i; ) {
        const a = i.assignedSlot || i.parentElement || ((o = i.getRootNode()) == null ? void 0 : o.host);
        a && s.push(a), i = a;
      }
      return s;
    })().includes(this) || document.activeElement === document.body) && this.triggerElement.focus();
  }
  async manageOpen(t) {
    var n;
    if (!this.isConnected && this.open) return;
    this.hasUpdated || await this.updateComplete, this.open ? (kt.add(this), this.willPreventClose && (document.addEventListener("pointerup", () => {
      this.dialogEl.classList.toggle("not-immediately-closable", !1), this.willPreventClose = !1;
    }, { once: !0 }), this.dialogEl.classList.toggle("not-immediately-closable", !0))) : (t && ((n = this._focusTrap) == null || n.deactivate(), this._focusTrap = null, this.dispose()), kt.remove(this)), this.open && this.state !== "opened" ? this.state = "opening" : !this.open && this.state !== "closed" && (this.state = "closing"), this.managePopoverOpen();
    const o = this.getRootNode();
    this.type === "auto" && (this.open ? o.addEventListener("focusout", this.closeOnFocusOut, { capture: !0 }) : o.removeEventListener("focusout", this.closeOnFocusOut, { capture: !0 })), (this.type === "modal" || this.type === "page") && (this.open ? o.addEventListener("cancel", this.closeOnCancelEvent, { capture: !0 }) : o.removeEventListener("cancel", this.closeOnCancelEvent, { capture: !0 }));
  }
  bindEvents() {
    var t;
    (t = this.strategy) == null || t.abort(), this.strategy = void 0, this.hasNonVirtualTrigger && this.triggerInteraction && (this.strategy = new re[this.triggerInteraction](this.triggerElement, { overlay: this }));
  }
  handleBeforetoggle(t) {
    t.newState !== "open" && this.handleBrowserClose(t);
  }
  handleBrowserClose(t) {
    var n;
    t.stopPropagation(), (n = this.strategy) != null && n.activelyOpening ? this.manuallyKeepOpen() : this.open = !1;
  }
  manuallyKeepOpen() {
    this.open = !0, this.placementController.allowPlacementUpdate = !0, this.manageOpen(!1);
  }
  handleSlotchange() {
    var t, n;
    this.elements.length ? this.hasNonVirtualTrigger && ((n = this.strategy) == null || n.prepareDescription(this.triggerElement)) : (t = this.strategy) == null || t.releaseDescription();
  }
  shouldPreventClose() {
    const t = this.willPreventClose;
    return this.willPreventClose = !1, t;
  }
  requestSlottable() {
    this.lastRequestSlottableState !== this.open && (this.open || document.body.offsetHeight, this.dispatchEvent(new le("overlay-content", this.open ? {} : ce)), this.lastRequestSlottableState = this.open);
  }
  willUpdate(t) {
    var n;
    if (this.hasAttribute("id") || this.setAttribute("id", `${this.tagName.toLowerCase()}-${ae()}`), t.has("open") && (this.hasUpdated || this.open) && this.manageOpen(t.get("open")), t.has("trigger")) {
      const [s, i] = ((n = this.trigger) == null ? void 0 : n.split("@")) || [];
      this.elementResolver.selector = s ? `#${s}` : "", this.triggerInteraction = i;
    }
    let o = !1;
    t.has(se) && (o = this.triggerElement, this.triggerElement = this.elementResolver.element), t.has("triggerElement") && (o = t.get("triggerElement")), o !== !1 && this.bindEvents();
  }
  updated(t) {
    super.updated(t), t.has("placement") && (this.placement ? this.dialogEl.setAttribute("actual-placement", this.placement) : this.dialogEl.removeAttribute("actual-placement"), this.open && t.get("placement") !== void 0 && this.placementController.resetOverlayPosition()), t.has("state") && this.state === "closed" && t.get("state") !== void 0 && this.placementController.clearOverlayPosition();
  }
  renderContent() {
    return mt`
            <slot @slotchange=${this.handleSlotchange}></slot>
        `;
  }
  get dialogStyleMap() {
    return { "--swc-overlay-open-count": vt.openCount.toString() };
  }
  renderPopover() {
    return mt`
            <div
                class="dialog"
                part="dialog"
                role=${st(this.type === "modal" || this.type === "page" ? "dialog" : void 0)}
                aria-modal=${st(this.type === "modal" || this.type === "page" ? "true" : void 0)}
                placement=${st(this.requiresPositioning ? this.placement || "right" : void 0)}
                popover=${st(this.popoverValue)}
                style=${ue(this.dialogStyleMap)}
                @beforetoggle=${this.handleBeforetoggle}
                @close=${this.handleBrowserClose}
                ?is-visible=${this.state !== "closed"}
            >
                ${this.renderContent()}
            </div>
        `;
  }
  render() {
    return mt`
            ${this.renderPopover()}
            <slot name="longpress-describedby-descriptor"></slot>
        `;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("close", () => {
      this.open = !1;
    }), this.hasUpdated && this.bindEvents();
  }
  disconnectedCallback() {
    var t;
    (t = this.strategy) == null || t.releaseDescription(), this.open = !1, super.disconnectedCallback();
  }
};
L.styles = [ke], L.openCount = 1, F([N({ type: Boolean })], L.prototype, "delayed", 1), F([St(".dialog")], L.prototype, "dialogEl", 2), F([N({ type: Boolean })], L.prototype, "disabled", 1), F([pe({ flatten: !0, selector: ':not([slot="longpress-describedby-descriptor"], slot)' })], L.prototype, "elements", 2), F([N({ type: Number })], L.prototype, "offset", 2), F([N({ type: Boolean, reflect: !0 })], L.prototype, "open", 1), F([N()], L.prototype, "placement", 2), F([N({ attribute: "receives-focus" })], L.prototype, "receivesFocus", 2), F([St("slot")], L.prototype, "slotEl", 2), F([de()], L.prototype, "state", 1), F([N({ type: Number, attribute: "tip-padding" })], L.prototype, "tipPadding", 2), F([N()], L.prototype, "trigger", 2), F([N({ attribute: !1 })], L.prototype, "triggerElement", 2), F([N({ attribute: !1 })], L.prototype, "triggerInteraction", 2), F([N()], L.prototype, "type", 2);
let Ke = L;
export {
  Ge as LONGPRESS_INSTRUCTIONS,
  Ke as Overlay
};
//# sourceMappingURL=Overlay-DDWP3X23.js.map
